/**
 * De vaste woorden van de site (docs/VORMGEVING.md › Woorden). Eén bron voor de zachte tip in de
 * pagina-editor én voor de test op de standaardteksten (data/wordList.test.ts).
 *
 * - Plan een afspraak: elke boekknop; in de lade kies je de behandeling of het consult.
 * - Huidtest: de online vragenlijst. Huidanalyse: alleen het kijken in de salon.
 * - Protocol: het pakket producten in volgorde. Huidplan: jouw plan in Mijn omgeving.
 * - Beloftes: "volgens mijn werkwijze", nooit "altijd door mij" (er werkt ook een collega).
 */
export type WordRule = { pattern: RegExp; tip: string }

export const wordRules: readonly WordRule[] = [
  { pattern: /huidadvies/i, tip: 'De online vragenlijst heet “huidtest”.' },
  { pattern: /plan een behandeling/i, tip: 'Boekknoppen zeggen “Plan een afspraak”; de behandeling kies je in de lade.' },
  { pattern: /^plan \{consultName\}$/i, tip: 'Boekknoppen zeggen “Plan een afspraak”; het consult kies je in de lade.' },
  { pattern: /op papier/i, tip: 'Het huidplan staat in Mijn omgeving, niet op papier.' },
  { pattern: /altijd (door mij|door \{firstName\}|behandeld door)/i, tip: 'Er werkt ook een collega: schrijf “volgens mijn werkwijze”.' },
  { pattern: /jouw protocol/i, tip: 'Schrijf “je protocol”: de site gebruikt overal “je”.' },
]

/** De tips die bij een tekst horen (leeg = in orde). */
export function wordTips(text: string): string[] {
  return wordRules.filter((r) => r.pattern.test(text)).map((r) => r.tip)
}
